import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import { posthog } from "@/lib/posthog";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);
